import Confirmation from './Confirmation';

export { Confirmation };
export default Confirmation;
